import {useSelector} from '@modifi/redux'
import {useCallback} from 'react'
import {useBasePath} from '../../base-path'
import {selectFlatRouteList} from '../../../data/routes'

type Result = <T extends string | {pathname: string}>(target: T) => T

const useBasePathPrefix = (): Result => {
  const currentBasePath = useBasePath()
  const validRoutes = useSelector(selectFlatRouteList)

  return useCallback(
    <T extends string | {pathname: string}>(target: T): T => {
      const isStringTarget = typeof target === 'string'
      const targetAsString = isStringTarget ? target : target.pathname

      // as long as we don't have the routes - don't change anything
      if (validRoutes.length === 0 || !currentBasePath || targetAsString.startsWith('http')) {
        return target
      }

      // provided target is already a valid route
      if (targetAsString.startsWith(currentBasePath) && validRoutes.includes(targetAsString)) {
        return target
      }

      if (typeof target === 'string') {
        return `${currentBasePath}${targetAsString}` as T
      }
      return {
        // @ts-expect-error ignore for now
        ...target,
        pathname: `${currentBasePath}${targetAsString}`,
      }
    },
    [currentBasePath, validRoutes]
  )
}

export default useBasePathPrefix
